<template>
  <v-form ref="form">
    <v-row align="baseline">
      <v-col cols="6" md="2">
        <v-text-field
          v-model="currFilters.first_name"
          :label="$t('PROFILE.FIRST_NAME')"
        />
      </v-col>
      <v-col cols="6" md="2">
        <v-text-field
          v-model="currFilters.last_name"
          :label="$t('PROFILE.LAST_NAME')"
        />
      </v-col>
      <v-col cols="6" md="2">
        <source-filter
          v-model="currFilters.source_id"
          item-text="name"
          item-value="id"
          :label="$t('ORDERS.SOURCE')"
          multiple
          chips
          small-chips
          deletable-chips
        />
      </v-col>
      <v-col cols="6" md="2">
        <type-filter
          v-model="currFilters.type_id"
          item-text="name"
          item-value="id"
          :label="$t('ITEM.TYPE')"
          multiple
          chips
          small-chips
          deletable-chips
        />
      </v-col>
      <v-col cols="6" md="2">
        <status-filter
          v-model="currFilters.status_id"
          item-text="name"
          item-value="id"
          :label="$t('ITEM.STATUS')"
          multiple
          chips
          small-chips
          deletable-chips
        />
      </v-col>
      <v-col cols="6" md="2">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-1 mr-1"
              color="grey"
              depressed
              outlined
              @click="reset"
              v-on="on"
            >
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>
        <v-btn
          class="mb-1 ml-4"
          type="submit"
          color="primary"
          depressed
          @click.prevent="setFilters"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import StatusFilter from '@/modules/inhabitant_changes/components/filters/StatusFilter';
import SourceFilter from '@/modules/inhabitant_changes/components/filters/SourceFilter';
import TypeFilter from '@/modules/inhabitant_changes/components/filters/TypeFilter';
import { mapState } from 'vuex';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'BuildingsListFilters',

  components: {
    StatusFilter,
    SourceFilter,
    TypeFilter
  },

  mixins: [listFilters],
  computed: {
    ...mapState('inhabitant_changes', ['filters'])
  },

  methods: {
    reset() {
      this.$refs.form.reset();
      this.currFilters = {};
      this.setFilters();
    }
  }
};
</script>
